<template>
  <div
    class="tab-pane fade active show"
    id="dayPeopleFlow"
    role="tabpanel"
    aria-labelledby="dayPeopleFlow-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="">請選擇</option>
            <option value="-1">全部</option>
            <option
              v-for="(list, index) in toiletCountScenicArea"
              :key="index"
              :value="list.id"
            >
            <!-- <option
              v-for="(list, index) in toiletCountScenicArea"
              :key="index"
              :value="list.id"
            > -->
              {{ list.name }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">公廁</label>
          <select class="form-control" v-model="selectTioletpublicPlaceId">
            <option value="-1">全部</option>
            <option
              v-for="(list, index) in scenicToilets"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>
        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryData"
            :disabled="isWaitCCTVList"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitCCTVList"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

        <h1 style="margin-top: 0px">當日公廁人次</h1>

        <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
          <div class="col order-2 order-md-1">
            <div class="card card-clean h-100">
              <div class="bd-example">
                <table
                  id="dayToiletFlow"
                  class="w3-table-all table table-hover table-striped"
                >
                  <thead class="table-dark">
                    <tr>
                      <th scope="col" width="5%">#</th>
                      <th scope="col">時間</th>
                      <th scope="col">景區</th>
                      <th scope="col">位置</th>
                      <th scope="col">人次</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in peopleFlowData"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td style="white-space: pre-line;">{{ item.time }}</td>  <!-- style讓 \n可以換行-->
                      <td>{{ item.areaName }}</td>
                      <td>{{ item.publicPlaceName }}</td>
                      <td>{{ item.peopleCount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col order-1  order-md-2 pt-4">
            <div id="dayTioletPeopleChart">
                        <apexchart
                          type="area"
                          height="200"
                          :options="chartSetting"
                          :series="chartData"
                        ></apexchart>
            </div>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import { postToiletPeopleFlow } from '../../api/eastCoastDataApi/ElkQuery/PeopleFlowElk'
import ApexchartObject from '../../utils/apexchartObject/searchToiletCount'
import exportCSV from "../../utils/exportCSV";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: "",
      scenicToilets: [],
      selectTioletpublicPlaceId: "-1",
      toiletCCTVGroupby: [],
      peopleFlowData: [],
      isWaitCCTVList: false,
      chartData:[],
      chartSetting: {...ApexchartObject.sumPeopleFlow},
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  watch: {
    async selectScenicAreaId() {
      this.isWaitCCTVList = true;
      this.selectTioletpublicPlaceId = "-1";
      this.scenicToilets = [];

      let condition={};
      let data= [];
      if(this.selectScenicAreaId === ""){
        this.isWaitCCTVList = false;
        return [];
      }

      if (this.selectScenicAreaId === -1) {
        // //若selectScenicAreaId為全選，則id 為toiletCountScenicArea的 id 陣列

        const selectScenicAreaId = await this.toiletCountScenicArea.map((s) => s.id);
        condition.id = selectScenicAreaId;
        const res = await this.$store.dispatch("toiletMgt/getMutiScenicToiletData", condition);
        // console.log("dispatch- res",res);
        data = res;
      }else{
        condition.id = [this.selectScenicAreaId];
        await this.$store.dispatch("toiletMgt/getToiletData", condition);
        data = this.$store.getters["toiletMgt/getScenicToilets"]({
          scenicAreaId: condition.id,
        });

      }

      // console.log(data)

      this.scenicToilets = Utils.isEmptyObject(data)
        ? []
        : data[0].publicPlace;

      // console.log(" data[0]", data[0].publicPlace)
      this.isWaitCCTVList = false;
    },

    toiletCCTVList() {
      this.toiletCCTVGroupby = Utils.arrayGroupBy(
        this.toiletCCTVList,
        CONST.PUBLIC_PLACE_ID,
        CONST.TOILETS
      );
    },
  },
  computed: {
    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },
    toiletCountScenicArea() {
      return this.scenicAreaList.filter(
        (s) =>
          s.additionInfo &
          CONST.SCENIC_AREA_ADDITION_INFO_ENUM.TOILET_PEOPLE_FLOW
      );
    },
    // ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


    ...mapGetters({
      toiletCCTVList: "getScenicAreaToiletPeopleFlowVideoCamera",
    }),
  },
  methods: {
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },
    async queryCSV() {
      this.isWaitCCTVList = true;
      const peopleFlowData = await this.searchData();
      if (Utils.isEmptyObject(peopleFlowData)) {
        alert("沒有資料");
        return;
      }

      const csvContent = [["日期", "風景區", "位置", "人次"]];
      peopleFlowData.forEach((item) => {
        const row = [];
        row.push(item.time.replace(/\n/g, ''));
        row.push(item.areaName);
        row.push(item.publicPlaceName);
        row.push(item.peopleCount);

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_當日公廁人次.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
      this.isWaitCCTVList = false;
    },

    async queryData() {
      this.isWaitCCTVList = true;
      this.peopleFlowData = await this.searchData();
      this.updateTable();
      this.setChartData(this.peopleFlowData)
      this.isWaitCCTVList = false;
    },

    async searchData() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        toilets: [],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "hour"
      }

      if(this.selectScenicAreaId === ""){
        alert("請選擇景區");
        return [];
      }

      if(this.selectScenicAreaId === -1){

        const areaId=await this.toiletCountScenicArea.map((s) => s.id);
        condition.areas.push(...areaId);
        // console.log("condition.areas",condition.areas);
        
      }

      if(this.selectScenicAreaId > -1) {
        condition.areas.push(this.selectScenicAreaId)
      }

      if(this.selectTioletpublicPlaceId > -1) {
        condition.toilets.push(this.selectTioletpublicPlaceId)
      }

      const result = await postToiletPeopleFlow(condition)
      if(!result.success){
        return []
      }

      const total = {
        time: '統計',
        areaName: '',
        publicPlaceName: '',
        peopleCount: 0
      }

      const dataList = result.data.map( e => {
        const data ={}
        data.areaName = e.areaName
        data.time =  `${moment(e.dateTime).format('YYYY-MM-DD')} \n ${moment(e.dateTime).format('HH')}~${moment(e.dateTime).add(1, 'h').format('HH')}`
        data.publicPlaceName = e.placeName
        data.peopleCount = e.peopleFlow
        data.dateTime = e.dateTime

        total.peopleCount = total.peopleCount + data.peopleCount

        return data
      })

      dataList.push(total)
      return dataList
    },

    setChartData(dataList) {
      if(dataList.length < 1) {
        this.chartData = []
        this.chartSetting = ApexchartObject.sumPeopleFlow
        return
      }
      
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
      const groupByPublicPlaceNameList = Utils.arrayGroupBy(list, 'publicPlaceName', 'countList')

      const publicPlaceCountList = []
      groupByPublicPlaceNameList.forEach(e => {
        const sumList = Object.values(e.countList.reduce((acc, obj) => {
          //將相同景區的人數相加
          if (acc[obj.time]) {
            acc[obj.time].peopleCount += obj.peopleCount;
          } else {
            acc[obj.time] = { ...obj };
          }
          return acc;
        }, {}));

        publicPlaceCountList.push(sumList)
      })

      // console.log("publicPlaceCountList",publicPlaceCountList)

      
      this.chartData = []
      publicPlaceCountList.forEach(e => {
        const count = e.map((d, i) => {
          return d.peopleCount
        })
        
        this.chartData.push({name: e[0].publicPlaceName, data: count})
      }) 
      // console.log("this.chartData",this.chartData)
      let chartSetting = {...this.chartSetting}
      chartSetting.tooltip.x.formatter = function (val) {
        return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} `;
      };
      let xaxisCategories = publicPlaceCountList[0].map((d, i) => {
        const hour = moment(d.dateTime).format("HH:mm");
        const date = moment(d.dateTime).format("YYYY/MM/DD");
        const category = `${date} ${hour}`;
        return category
      })

      if(xaxisCategories.length === 1) {
        const data = Utils.setapexChartZero(xaxisCategories, this.chartData)
        xaxisCategories = data.xaxisCategories
        this.chartData = data.chartData
      }

      chartSetting = {...chartSetting, ...{xaxis:{categories: xaxisCategories}}} //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678
      this.chartSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    initTable: function () {
      this.table = $("#dayToiletFlow").DataTable({
        aoColumns: [
          ...new Array($("#dayToiletFlow th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.updateTable();
  },
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>